import React from "react";

import { Spacer } from "shared/layout";
import { Icon, MutedText } from "shared/styles";
import { space } from "shared/styles/constants";
import { IAction, IFormOption } from "shared/types";
import { RadioGroup } from "../Form";
import { ActionContainer, ActionContainerProps } from "../Action/styles";

interface ActionWithOptionsProps extends IAction, ActionContainerProps {
  dataTestId?: string;
  iconSize?: keyof typeof space;
  disabled?: boolean;
  viewLabel?: string;
  showViewLabel?: boolean;
  tabIndex?: number;
  value?: string;
  options: IFormOption[];
  updateOption: (value: string) => void;
}

export const ActionWithOptions = React.forwardRef<HTMLButtonElement, ActionWithOptionsProps>(
  (
    {
      icon,
      iconComponent,
      actionIcon,
      label,
      viewLabel,
      subLabel,
      handleClick,
      size = "s",
      dataTestId,
      iconSize,
      tabIndex,
      showViewLabel,
      options = [],
      updateOption,
      value,
      isActive,
      ...props
    },
    ref
  ) => {
    return (
      <ActionContainer
        ref={ref}
        type="button"
        size={size}
        data-testid={dataTestId}
        tabIndex={tabIndex}
        isActive={isActive}
        {...props}
        style={{
          alignItems: "stretch",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
            minWidth: "fit-content",
          }}
          onClick={() => {
            handleClick?.(options[0]?.value);
          }}
        >
          {icon && !iconComponent && <Icon as={icon} size={iconSize} />}
          {iconComponent}
          <Spacer size="xxs" spaceDirection="horizontal">
            <span>{showViewLabel ? viewLabel : label}</span>
            {subLabel && (
              <>
                <MutedText>•</MutedText>
                <MutedText>{subLabel}</MutedText>
              </>
            )}
          </Spacer>
          {actionIcon && <Icon size="s" as={actionIcon} />}
        </div>
        {isActive && value && (
          <Spacer size="xs" style={{ borderLeft: "1px solid #4C4C4C" }}>
            <RadioGroup
              options={options}
              name={value}
              isDisabled={!isActive}
              onChange={e => {
                updateOption((e.target as HTMLInputElement).value);
              }}
            />
          </Spacer>
        )}
      </ActionContainer>
    );
  }
);
